import { questionnaireActionTypes } from '@actions/actionTypes/questionnaire';
import { questionnaireInitialState, QuestionnaireState } from './initialState/questionnaire';
import { AnyAction } from 'redux';

export const questionnaireReducer = (
  state = questionnaireInitialState,
  action: AnyAction
): QuestionnaireState => {
  switch (action.type) {
    case questionnaireActionTypes.CURRENT_QUESTIONNAIRE_LOADING: {
      return { ...state, isCurrentQuestionnaireLoading: action.payload };
    }
    case questionnaireActionTypes.CURRENT_QUESTIONNAIRE_FAILURE: {
      return { ...state, isCurrentQuestionnaireFailure: action.payload };
    }
    case questionnaireActionTypes.SET_CURRENT_QUESTIONNAIRE: {
      return { ...state, currentQuestionnaire: action.payload };
    }
    case questionnaireActionTypes.SET_CURRENT_QUESTIONNAIRE_RENDERER: {
      return { ...state, questionnaireRenderer: action.payload };
    }
    case questionnaireActionTypes.QUESTIONNAIRES_LOADING: {
      return { ...state, isQuestionnairesLoading: action.payload };
    }
    case questionnaireActionTypes.SET_QUESTIONNAIRES: {
      return { ...state, questionnaires: action.payload };
    }
    case questionnaireActionTypes.QUESTIONNAIRES_FAILURE: {
      return { ...state, isQuestionnairesFailure: action.payload };
    }
    //// ------ FOR GRID -------- /////
    case questionnaireActionTypes.SET_QUESTIONNAIRES_TOTAL: {
      return { ...state, total: action.payload };
    }
    case questionnaireActionTypes.SET_QUESTIONNAIRES_LIMIT: {
      return { ...state, limit: action.payload };
    }
    case questionnaireActionTypes.SET_QUESTIONNAIRES_OFFSET: {
      return { ...state, offset: action.payload };
    }
    ///// ------ POST/PUT/DELETE ----- ////
    case questionnaireActionTypes.EDITING_QUESTIONNAIRE_LOADING: {
      return { ...state, isEditingQuestionnaireLoading: action.payload };
    }
    case questionnaireActionTypes.SET_EDITING_QUESTIONNAIRE: {
      return { ...state, editingQuestionnaire: action.payload };
    }
    case questionnaireActionTypes.EDITING_QUESTIONNAIRE_FAILURE: {
      return { ...state, isEditingQuestionnaireFailure: action.payload };
    }
    case questionnaireActionTypes.DELETING_QUESTIONNAIRE_LOADING: {
      return { ...state, isDeletingQuestionnaireLoading: action.payload };
    }
    case questionnaireActionTypes.DELETING_QUESTIONNAIRE_FAILURE: {
      return { ...state, isDeletingQuestionnaireFailure: action.payload };
    }
    default: {
      return state;
    }
  }
};
